import React, { ChangeEvent, ReactElement, ReactNode } from 'react';
import { Box, Tab, Tabs } from '@material-ui/core';
import { Body1 } from '../../atoms';
import { useTranslation } from 'react-i18next';

export interface ITabContainerProps {
	tabs: ReactNode[];
	centered?: boolean | undefined;
	activeTab: number;
	requiredLabel?: boolean;
	onTabChange?: (activeTab: number) => void;
}

export function TabContainer(props: ITabContainerProps): ReactElement {
	const { tabs, centered, activeTab, requiredLabel, onTabChange } = props;
	const { t } = useTranslation('general');

	function onChange(_: ChangeEvent<{}>, newValue: number) {
		if (onTabChange) onTabChange(newValue);
	}

	return (
		<Box className="tab-container">
			<Tabs
				indicatorColor="primary"
				centered={centered}
				value={activeTab}
				onChange={onChange}
			>
				{tabs.map((tab: ReactNode, index: number) => (
					<Tab key={index} label={tab} />
				))}
			</Tabs>
			{requiredLabel && <Body1>({t('required').toLowerCase()})</Body1>}
		</Box>
	);
}
